import React from "react";

const steps = [
  {
    title: "Discovery and Planning",
    text: "We understand your business goals, target users, and required features.",
  },
  {
    title: "UI/UX Design",
    text: "Our designers create user flows, wireframes, and prototypes.",
  },
  {
    title: "Development",
    text: "Our developers build the application using the right technology stack.",
  },
  {
    title: "Testing",
    text: "We test functionality, security, speed, and device compatibility.",
  },
  {
    title: "App Launch",
    text: "We manage the Google Play Store and Apple App Store submission process.",
  },
  {
    title: "Maintenance and Updates",
    text: "We continue supporting your app after launch.",
  },
];

export default function Section10() {
  return (
    <div className="w-full Section10 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section10-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Our Mobile App Development Process
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 mt-8">
          {steps.map((step, index) => (
            <div key={step.title} className="bg-white rounded-[8px] p-5 relative">
              <span className="text-[#cd2122] text-3xl font-bold font-open block mb-2">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="text-[16px] font-bold text-[#151515] mb-2 font-open">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-[#535353] leading-[20px] font-open">
                {step.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
